export default [
  {
    question: 'บริการ E-hailing หรือ Ride-hailing คืออะไร?',
    answer: 'E-hailing หรือ Ride-hailing คือ บริการเรียกรถผ่านแอพพลิเคชั่น เป็นการให้บริการรับส่งผู้โดยสารด้วยยานพาหนะหรือรถยนต์ส่วนตัว'
  },
  {
    answer: 'กรอกข้อมูลเพื่อสมัครเป็นพาร์ทเนอร์ขับรถรับจ้างกับ airasia ride ได้<a href="https://form.jotform.com/222510714460445" target="_blank">ที่นี่</a> สำหรับแอร์เอเชีย ฟู้ด ไรเดอร์ หรือแมสเซนเจอร์ airasia xpress สามารถสมัครได้<a href="https://form.jotform.com/222152536739054" target="_blank">ที่นี่</a> จากนั้นรอทีมงานของเราติดต่อกลับไปได้เลย!',
    question: 'สมัครขับรถแอร์เอเชียต้องทำอย่างไรบ้าง?'
  },
  {
    answer: '<ul><li>สัญชาติไทย</li><li>มีอายุระหว่าง 22 - 60 ปี</li><li>มีใบขับขี่สาธารณะ</li><li>มีประสบการณ์การขับรถอย่างน้อย 3 ปี</li></ul>',
    question: 'สมัครขับรถแอร์เอเชียต้องมีคุณสมบัติอะไรบ้าง?'
  },
  {
    answer: 'หากสนใจสมัครขับรถกับ แอร์เอเชีย ไรด์ คุณจะต้องมีรถยนต์สำหรับรับส่งผู้โดยสารจากจุดหนึ่งไปยังอีกจุดหนึ่ง แต่หากสนใจเข้าร่วมเป็นไรเดอร์ขับรถส่งอาหารกับ แอร์เอเชีย ฟู้ด หรือแมสเซนเจอร์ส่งของ airasia xpress คุณไม่จำเป็นต้องมีรถยนต์ แค่มีมอเตอร์ไซค์หรือรถจักรยานยนต์ก็สามารถขับส่งอาหารเดลิเวอรี่และส่งพัสดุกับเราได้แล้ว',
    question: 'พาร์ทเนอร์คนขับของแอร์เอเชียจำเป็นต้องมีรถยนต์หรือไม่?'
  },
  {
    answer: 'airasia ride ให้บริการเฉพาะเขตในกรุงเทพมหานครเท่านั้น ส่วน airasia food ครอบคลุมทั้งพื้นที่เขตกรุงเทพมหานครและปริมณฑล',
    question: 'airasia ride และ airasia food ให้บริการในพื้นที่ไหนบ้าง?'
  },
  {
    question:'แอร์เอเชียช่วยเหลือพาร์ทเนอร์คนขับในการขอรับใบอนุญาตขับขี่สาธารณะและใบอนุญาตรับงานผ่านแอพ E-hailing หรือ Ride-hailing หรือไม่?',
    answer:'airasia Super App ช่วยเหลือพาร์ทเนอร์คนขับในการขอรับใบอนุญาตขับขี่สาธารณะและใบอนุญาตรับงานผ่านแอพ E-hailing หรือ Ride-hailing'
  },
  {
    question:'รถยนต์ที่ใช้ขับกับ แอร์เอเชีย ไรด์ ควรมีอายุการใช้งานเท่าไหร่?',
    answer:'สำหรับรถแท็กซี่ที่เข้าร่วม แอร์เอเชีย ไรด์ จะต้องมีอายุไม่เกิน 10 ปี หากเป็นรถยนต์ทั่วไปต้องมีอายุไม่เกิน 9 ปี'
  },
  {
    question:'มีประกันคุ้มครองสำหรับพาร์ทเนอร์คนขับที่เข้าร่วม airasia ride และพาร์ทเนอร์ไรเดอร์ขับรถส่งอาหาร airasia food หรือไม่?',
    answer:'มี ผู้ที่สมัครขับรถ แอร์เอเชีย ไรด์ ไรเดอร์เดลิเวอรี่อาหารกับ แอร์เอเชีย ฟู้ด และแมสเซนเจอร์ส่งพัสดุกับ airasia xpress ทุกคนจะได้รับความคุ้มครองจากประกันภัย'
  }
]
